import React, {useEffect} from 'react';

// Pinned to the BOTTOM of the viewport so it can never cover the sticky header.
const PreviewRibbon: React.FC = () => {
    // Being fixed, the ribbon would otherwise sit on top of whatever is at the
    // bottom of the page (the footer) - reserve its height while it is up.
    useEffect(() => {
        document.body.classList.add('lnk-hero-preview-active');
        return () => document.body.classList.remove('lnk-hero-preview-active');
    }, []);

    return (
        <div className="lnk-hero__preview-ribbon" role="status">
            מצב תצוגה מקדימה — התוכן לא פורסם
        </div>
    );
};

export default PreviewRibbon;
